<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.ProjectInfos.Title_2 }}
            <span class="subtitle hero-subtitle">{{ $lang.Menus.FillFields }}</span>

            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">
                    {{ $lang.Menus.ContinueBtn }}
                </b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body">
                <div class="wizard-pair">
                    <!-- The five project fields; the same checks and edit locks as before. -->
                    <div class="wizard-card">
                        <div class="wizard-grid">
                            <b-field :label="$lang.ProjectInfos.LastUserName" :type="{ 'is-danger': hasError_lastUserName }" :message="emptyWarning_lastUserName">
                                <b-input v-model="lastUserName" :disabled="$store.state.lastUserName !== undefined && isCompleted && $store.state.isEdit" @input="enableManuelSave()"></b-input>
                            </b-field>
                            <b-field :label="$lang.ProjectInfos.PanelManifacturer" :type="{ 'is-danger': hasError_panelManifacturer }" :message="emptyWarning_panelManifacturer">
                                <b-input v-model="panelManifacturer" :disabled="$store.state.panelManifacturer !== undefined && isCompleted && $store.state.isEdit" @input="enableManuelSave()"></b-input>
                            </b-field>
                            <b-field :label="$lang.ProjectInfos.ProjectName" :type="{ 'is-danger': hasError_projectName }" :message="emptyWarning_projectName">
                                <b-input v-model="projectName" :disabled="projectName !== undefined && isCompleted && $store.state.isEdit" @input="enableManuelSave()"></b-input>
                            </b-field>
                            <b-field :label="$lang.ProjectInfos.PanelName" :type="{ 'is-danger': hasError_panelName }" :message="emptyWarning_panelName">
                                <b-input v-model="panelName" :disabled="panelName !== undefined && isCompleted && $store.state.isEdit" @input="enableManuelSave()"></b-input>
                            </b-field>
                            <b-field :label="$lang.ProjectInfos.PanelNo" :type="{ 'is-danger': hasError_panelNo }" :message="emptyWarning_panelNo">
                                <b-input v-model="panelNo" type="number" min="0" :disabled="panelNo !== undefined && isCompleted && $store.state.isEdit" @input="setPanelNoValidity(); enableManuelSave();"></b-input>
                            </b-field>
                        </div>
                    </div>

                    <!-- Rated current: three radio rows; multi-section adds the two eye counts. -->
                    <div class="wizard-card">
                        <p class="wizard-card-head"><span v-html="$lang.ProjectInfos.RatedCurrent"></span></p>
                        <b-field :type="{ 'is-danger': hasError_ratedCurrent }" :message="emptyWarning_ratedCurrent">
                            <div class="choice-list">
                                <div v-for="(option, index) in ['value_1', 'value_2', 'value_3']" :key="option" class="choice-row" :class="{ 'is-selected': currentRadio == option }">
                                    <b-radio v-model="currentRadio"
                                             :native-value="option"
                                             @input="setMultiEyed(); enableManuelSave();">
                                        <span v-html="currentslist[index]"></span>
                                    </b-radio>
                                </div>
                            </div>
                        </b-field>

                        <div v-if="isMultiEyed" class="wizard-grid wizard-card-split">
                            <b-field :label="$lang.ProjectInfos.TotalEyesNumber" :type="{ 'is-danger': hasError_totalEyeNumber }" :message="emptyWarning_totalEyeNumber">
                                <b-input v-model="totalEyesNumber" type="number" min="0" step="1" @input="setEyesNumberValidity(); enableManuelSave()"></b-input>
                            </b-field>
                            <b-field :label="$lang.ProjectInfos.EyeNumber"
                                     :type="{ 'is-danger': hasError_eyeNumber || hasError_eyeNumber_2 }"
                                     :message="hasError_eyeNumber ? $lang.ProjectInfos.EyeNumberTooHigh : (hasError_eyeNumber_2 ? $lang.Menus.EmptyWarning : '')">
                                <b-input v-model="eyesNumber" type="number" min="0" step="1" @input="setEyesNumberValidity(); enableManuelSave()"></b-input>
                            </b-field>
                        </div>
                    </div>
                </div>

                <!-- The application conditions, from the dictionary as before. -->
                <div class="wizard-notes">
                    <p class="wizard-notes-title"><span v-html="$lang.ProjectInfos.Title"></span></p>
                    <ul class="projectList1">
                        <li class="projectListItem1"> <span v-html="$lang.ProjectInfos.Info_1"></span></li>
                        <li class="projectListItem1">
                            <span v-html="$lang.ProjectInfos.Info_2"></span>
                            <ol class="projectList2">
                                <li class="projectListItem2"> <span v-html="$lang.ProjectInfos.Info_3"></span> </li>
                                <li class="projectListItem2"> <span v-html="$lang.ProjectInfos.Info_4"></span> </li>
                            </ol>
                        </li>
                        <li>
                            <span v-html="$lang.ProjectInfos.Info_5"></span>
                            <ul class="projectList3">
                                <li class="projectListItem3"> <span v-html="$lang.ProjectInfos.Info_6"></span> </li>
                                <li class="projectListItem3"> <span v-html="$lang.ProjectInfos.Info_7"></span> </li>
                                <li class="projectListItem3"> <span v-html="$lang.ProjectInfos.Info_8"></span> </li>
                                <li class="projectListItem3"> <span v-html="$lang.ProjectInfos.Info_9"></span> </li>
                                <li class="projectListItem3"> <span v-html="$lang.ProjectInfos.Info_10"></span> </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';

    export default {
        name: 'ProjectInfos',
        components: {
            VerticalStepBar
        },
        data() {
            return {
                isActive: true,
                isInfoOpened: false,
                projectName: '',
                panelName: '',
                panelNo: 0,
                lastUserName: '',
                panelManifacturer: '',
                currentslist: [],
                selectedRatedCurrent: 0,
                currentRadio: '',
                currentRadios: ['value_1', 'value_2', 'value_3'],
                totalEyesNumber: 0,
                eyesNumber: 0,
                isMultiEyed: false,
                canGoNextPage: false,
                isCompleted: false,

                hasError_projectName: false,
                emptyWarning_projectName: '',
                hasError_panelName: false,
                emptyWarning_panelName: '',
                hasError_panelNo: false,
                emptyWarning_panelNo: '',
                hasError_ratedCurrent: false,
                emptyWarning_ratedCurrent: '',
                hasError_totalEyeNumber: false,
                emptyWarning_totalEyeNumber: '',
                hasError_eyeNumber: false,
                hasError_eyeNumber_2: false,
                emptyWarning_lastUserName: '',
                hasError_lastUserName: false,
                emptyWarning_panelManifacturer: '',
                hasError_panelManifacturer: false,
            }
        },
        mounted() {
            this.currentslist = [];
            this.currentslist.push(this.$lang.ProjectInfos.CurrentVal_1);
            this.currentslist.push(this.$lang.ProjectInfos.CurrentVal_2);
            this.currentslist.push(this.$lang.ProjectInfos.CurrentVal_3);

            this.selectedRatedCurrent = this.currentslist[this.$store.state.ratedCurrentIndex - 1];
            this.currentRadio = this.currentRadios[this.$store.state.ratedCurrentIndex - 1];
            this.setMultiEyed();

            this.projectName = this.$store.state.projectName;
            this.panelName = this.$store.state.panelName;
            this.panelNo = this.$store.state.panelNo;
            this.panelManifacturer = this.$store.state.panelManifacturer;
            this.lastUserName = this.$store.state.lastUserName;
            this.totalEyesNumber = this.$store.state.totalEyesNumber;
            this.eyesNumber = this.$store.state.eyesNumber;
            this.$store.state.activeStep = 0;
            this.$store.state.isFooterFixed = true;
            this.isCompleted = this.$store.state.isCompleted;
        },
        methods: {
            submit() {
                this.controlInputs();

                if (this.canGoNextPage) {
                    this.setSavePayload();

                    this.$store.isPageOpenedFromStepBar = false;
                    this.$store.canPanelInfosOpen = true;
                    router.push('/panelInfos');
                }
            },
            enableManuelSave() {
                this.$store.state.canManuelSave = false;
            },
            setSavePayload() {
                var i = this.currentslist.indexOf(this.selectedRatedCurrent);
                i += 1;
                var payload = { langCode: this.$lang.Format.Lang, projectName: this.projectName, panelName: this.panelName, panelNo: this.panelNo, panelManifacturer: this.panelManifacturer, lastUserName: this.lastUserName, ratedCurrentIndex: i, panelRatedCurrent: this.selectedRatedCurrent, totalEyesNumber: this.totalEyesNumber, eyesNumber: this.eyesNumber, isCompleted: this.isCompleted };
                this.$store.commit('setProjectInfos', payload);
            },
            setPanelNoValidity() {
                if (this.panelNo < 0) {
                    this.panelNo = 0;
                }

                var value = (this.panelNo - Math.floor(this.panelNo)) !== 0;
                if (value) {
                    this.panelNo = 0;
                }
            },
            setMultiEyed() {
                var i = this.currentRadios.indexOf(this.currentRadio);

                this.selectedRatedCurrent = this.currentslist[i];
                if (i == 2) {
                    this.isMultiEyed = true;
                } else {
                    this.isMultiEyed = false;
                    this.eyesNumber = 1;
                    this.totalEyesNumber = 1;
                }
            },
            setEyesNumberValidity() {
                if (this.eyesNumber < 0) {
                    this.eyesNumber = 0;
                }
                if (this.totalEyesNumber < 0) {
                    this.totalEyesNumber = 0;
                }
                var value1 = (this.eyesNumber - Math.floor(this.eyesNumber)) !== 0;
                if (value1) {
                    this.eyesNumber = 0;
                }
                var value2 = (this.totalEyesNumber - Math.floor(this.totalEyesNumber)) !== 0;
                if (value2) {
                    this.totalEyesNumber = 0;
                }


                if (Number(this.eyesNumber) > Number(this.totalEyesNumber)) {
                    this.hasError_eyeNumber = true;
                } else {
                    this.hasError_eyeNumber = false;
                }
                this.hasError_eyeNumber_2 = false;
            },
            controlInputs() {
                var isOtherInputsEntered = false;
                if (this.lastUserName == '' || this.lastUserName == undefined) {
                    this.hasError_lastUserName = true;
                    this.emptyWarning_lastUserName = this.$lang.Menus.EmptyWarning;
                } else if (this.panelManifacturer == '' || this.panelManifacturer == undefined) {
                    this.hasError_panelManifacturer = true;
                    this.emptyWarning_panelManifacturer = this.$lang.Menus.EmptyWarning;
                } else if (this.projectName == '') {
                    this.hasError_projectName = true;
                    this.emptyWarning_projectName = this.$lang.Menus.EmptyWarning;
                } else if (this.panelName == '') {
                    this.hasError_panelName = true;
                    this.emptyWarning_panelName = this.$lang.Menus.EmptyWarning;
                } else if (this.panelNo == '') {
                    this.hasError_panelNo = true;
                    this.emptyWarning_panelNo = this.$lang.Menus.EmptyWarning;
                } else if (this.selectedRatedCurrent == null) {
                    this.hasError_ratedCurrent = true;
                    this.emptyWarning_ratedCurrent = this.$lang.Menus.EmptyWarning;
                } else {
                    isOtherInputsEntered = true;
                    if (!this.isMultiEyed) {
                        this.canGoNextPage = true;
                    }
                }

                if (this.isMultiEyed) {
                    if (this.totalEyesNumber == '') {
                        this.hasError_totalEyeNumber = true;
                        this.emptyWarning_totalEyeNumber = this.$lang.Menus.EmptyWarning;
                    } else if (Number(this.eyesNumber) > Number(this.totalEyesNumber)) {
                        this.hasError_eyeNumber = true;
                    } else if (this.eyesNumber == '') {
                        this.hasError_eyeNumber_2 = true;
                    } else {
                        if (isOtherInputsEntered) {
                            this.canGoNextPage = true;
                        }
                    }
                }

                if (this.lastUserName != '' || this.lastUserName == undefined) {
                    this.hasError_lastUserName = false;
                    this.emptyWarning_lastUserName = "";
                }
                if (this.panelManifacturer != '' || this.panelManifacturer == undefined) {
                    this.hasError_panelManifacturer = false;
                    this.emptyWarning_panelManifacturer = "";
                }
                if (this.projectName != '') {
                    this.hasError_projectName = false;
                    this.emptyWarning_projectName = "";
                }
                if (this.panelName != '') {
                    this.hasError_panelName = false;
                    this.emptyWarning_panelName = "";
                }
                if (this.panelNo != '') {
                    this.hasError_panelNo = false;
                    this.emptyWarning_panelNo = "";
                }
                if (this.selectedRatedCurrent != null) {
                    this.hasError_ratedCurrent = false;
                    this.emptyWarning_ratedCurrent = "";
                }
                if (this.totalEyesNumber != '') {
                    this.hasError_totalEyeNumber = false;
                    this.emptyWarning_totalEyeNumber = "";
                }
                if (this.eyesNumber != '' && this.eyesNumber <= this.totalEyesNumber) {
                    this.hasError_eyeNumber = false;
                    this.emptyWarning_ratedCurrent = "";
                }
            },
            openInfo() {
                if (!this.isInfoOpened) {
                    this.isInfoOpened = true;
                } else {
                    this.isInfoOpened = false;
                }
            }
        }
    };
</script>

<style>
    .wizard-card-split {
        padding-top: 16px;
        border-top: 1px solid #e3e3e3;
    }

    .projectList1 > li + li {
        margin-top: 8px;
    }

    .projectListItem2 {
        padding-left: 1.25rem;
        list-style-type: none;
    }

    .projectList3 {
        padding-left: 1.75rem;
    }

    .projectListItem3 {
        list-style-type: "-";
        padding-left: 0.25rem;
    }
</style>
